export default "__VITE_ASSET__e6d65a5e__"